import { greys } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import { lineHeight, size, weight } from "@clockwise/web-commons/src/styles/type.styles";

const container = {
  width: "100%",
  padding: "5px 0",
} as const;

const chipInput = {
  width: "100%",
  flex: "none",
} as const;

const chipFocused = {
  backgroundColor: greys.cloudyBlue,
} as const;

export const menuItem = {
  container: {
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  content: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  avatar: {
    marginRight: spacing.std,
  },
  text: {
    fontSize: size.md,
    lineHeight: lineHeight.std,
  },
  name: {
    color: greys.darkGreyBlue,
  },
  email: {
    color: greys.slate,
  },
  names: {
    fontSize: size.md,
    lineHeight: lineHeight.std,
    color: greys.slate,
    marginLeft: 30,
    marginTop: 5,
  },
  bold: {
    fontWeight: weight.bold,
  },
} as const;

const sectionTitle = {
  margin: "15px 0px 0px 15px",
  lineHeight: 1.5,
  fontSize: 14,
} as const;

export const calendar = {
  htmlColor: greys.slate,
  style: {
    marginRight: 15,
  },
} as const;

const avatar = {
  borderRadius: "50%",
  height: 30,
  width: 30,
  border: "2px solid white",
  marginLeft: -10,
} as const;

/////////////////
// Autosuggest
/////////////////
const suggestionsContainer = {
  marginTop: 5,
  paddingTop: 5,
} as const;

const suggestion = {
  display: "block",
} as const;

const suggestionHighlighted = {
  backgroundColor: greys.paleGrey,
} as const;

const suggestionsList = {
  margin: 0,
  padding: 0,
  listStyleType: "none",
} as const;

export const styles = {
  container,
  chipInput,
  chipFocused,
  avatar,
  suggestionsContainer,
  sectionTitle,
  suggestion,
  suggestionHighlighted,
  suggestionsList,
} as const;
